var _g, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuePoolIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1272_3256)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.46484,
    y: 4.23486,
    width: 38.5,
    height: 38.5,
    rx: 4,
    fill: "#DDAD00"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.457 29.625H22.457H20.5744C19.5696 29.625 18.7414 28.7968 18.7414 27.7921V20.8885C18.7414 19.8837 19.5696 19.0559 20.5744 19.0559H26.85C27.8548 19.0559 28.6831 19.8837 28.6831 20.8885V21.5162C28.683 21.6694 28.6222 21.8163 28.5138 21.9246L28.5138 21.9246C28.4054 22.0329 28.2585 22.0938 28.1054 22.0937H28.1054C27.7864 22.0937 27.5279 21.8352 27.5278 21.5162C27.5278 21.5162 27.5278 21.5162 27.5278 21.5162V20.8885C27.5278 20.5068 27.2317 20.2111 26.85 20.2111H20.5744C20.1927 20.2111 19.8966 20.5068 19.8966 20.8885V27.792C19.8966 28.1737 20.1927 28.4698 20.5744 28.4698H22.457C22.6101 28.4698 22.7571 28.5306 22.8656 28.6389C22.9739 28.7472 23.0347 28.8941 23.0347 29.0473C23.0347 29.2006 22.9739 29.3475 22.8655 29.4559C22.7572 29.5642 22.6103 29.6252 22.457 29.625Z",
    fill: "white",
    stroke: "#DDAD00",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8444 25.5958V25.5958C27.8442 25.2216 27.5408 24.9184 27.1666 24.9184H26.5392C26.3595 24.9184 26.1872 24.9897 26.06 25.1167L26.06 25.1167C25.9329 25.2438 25.8614 25.4162 25.8614 25.5958C25.8614 25.7756 25.9327 25.948 26.06 26.0752C26.187 26.2023 26.3594 26.2737 26.5392 26.2737H27.1666C27.3464 26.2737 27.5188 26.2023 27.6459 26.0752C27.7731 25.948 27.8444 25.7756 27.8444 25.5958ZM23.7648 24.6544C23.7648 23.6496 24.5929 22.8215 25.5975 22.8215H31.8736C32.8784 22.8215 33.7066 23.6496 33.7066 24.6544V31.5582C33.7066 32.5629 32.8784 33.3908 31.8736 33.3908H25.5975C24.5928 33.3908 23.7648 32.5629 23.7648 31.5582V24.6544Z",
    fill: "white",
    stroke: "#DDAD00",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0149 25.2818V25.2818C18.0149 25.1285 17.954 24.9817 17.8457 24.8734C17.7374 24.7651 17.5904 24.7042 17.4372 24.7043H17.4371H15.5545C15.1729 24.7043 14.8771 24.4081 14.8771 24.0266V17.1229C14.8771 16.7413 15.173 16.4454 15.5545 16.4454H21.8306C22.2122 16.4454 22.5081 16.7413 22.5081 17.1229V17.7506C22.5081 18.0696 22.7667 18.3281 23.0855 18.3282L18.0149 25.2818ZM18.0149 25.2818C18.015 25.4351 17.9542 25.582 17.8459 25.6903C17.7374 25.7987 17.5904 25.8595 17.4371 25.8595H15.5545C14.5497 25.8595 13.7219 25.0314 13.7219 24.0266V17.1229C13.7219 16.1181 14.5497 15.2902 15.5545 15.2902M18.0149 25.2818L15.5545 15.2902M15.5545 15.2902H21.8306C22.8354 15.2902 23.6633 16.1181 23.6633 17.1229V17.7506C23.6633 17.9039 23.6024 18.0508 23.4941 18.1591M15.5545 15.2902L23.4941 18.1591M23.4941 18.1591C23.3856 18.2674 23.2387 18.3282 23.0855 18.3282L23.4941 18.1591Z",
    fill: "white",
    stroke: "#DDAD00",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9172 18.0645V18.0645C15.917 18.2176 15.978 18.3645 16.0863 18.473C16.1946 18.5813 16.3414 18.6422 16.4946 18.6422H17.1224C17.2755 18.6422 17.4225 18.5813 17.5308 18.473C17.6391 18.3646 17.6998 18.2176 17.6998 18.0645L15.9172 18.0645ZM15.9172 18.0645C15.9172 17.7456 16.1757 17.487 16.4946 17.487M15.9172 18.0645L16.4946 17.487M16.4946 17.487H17.1224C17.4412 17.487 17.6997 17.7456 17.6998 18.0645L16.4946 17.487Z",
    fill: "white",
    stroke: "#DDAD00",
    strokeWidth: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8906 21.8301L20.9406 21.8301C20.9408 21.6768 21.0016 21.53 21.11 21.4217L21.11 21.4217C21.2183 21.3134 21.3653 21.2525 21.5183 21.2526H21.5184L22.1458 21.2526L22.1459 21.2526C22.2991 21.2525 22.4461 21.3134 22.5544 21.4217C22.6627 21.53 22.7236 21.6768 22.7236 21.8301L22.7236 21.8301C22.7237 21.9832 22.6628 22.1303 22.5546 22.2386C22.4461 22.3469 22.2991 22.4078 22.1458 22.4078H21.5184C21.3653 22.4078 21.2182 22.3469 21.1099 22.2386C21.0016 22.1303 20.9406 21.9832 20.9406 21.8301H20.8906ZM20.8906 21.8301C20.8906 21.9965 20.9568 22.1563 21.0745 22.2739C21.1922 22.3916 21.352 22.4578 21.5184 22.4578H22.1458C22.3124 22.4578 22.4721 22.3916 22.5899 22.2739L21.5184 21.2026C21.352 21.2025 21.1923 21.2687 21.0747 21.3864C20.9568 21.504 20.8908 21.6635 20.8906 21.8301Z",
    fill: "white",
    stroke: "#DDAD00",
    strokeWidth: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1272_3256",
    x: 0.464844,
    y: 0.234863,
    width: 46.5,
    height: 46.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1272_3256"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1272_3256",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuePoolIcon);
export default __webpack_public_path__ + "static/media/que-pool-icon.36b08bbea78cdc63cad078ec1b267899.svg";
export { ForwardRef as ReactComponent };